import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoginForm } from "../../Models/LoginModel";
import { LOGIN_REQ } from "../../Actions/userLoginAction";
import { LIST_UNIVERSITIES_RESET } from "../../Actions/universityAction";
export default function Login() {
  const [LoginFormData, setLoginFormData] = useState(LoginForm);
  const { accessToken, Login_error, Login_Loading } = useSelector(
    (store) => store.LoginReducer
  );

  const dispatch = useDispatch();
  const Navigate = useNavigate();

  // Store the Login information

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setLoginFormData({ ...LoginFormData, [name]: value });
  };

  // To submit Login data
  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (
      LoginFormData.Password === "" ||
      (LoginFormData.Password == null && LoginFormData.Username === "") ||
      LoginFormData.Username === null
    ) {
      alert("please fill all details !");
    } else if (
      LoginFormData.Username === "" ||
      LoginFormData.Username === null
    ) {
      alert("please Enter your email details!");
    } else if (
      LoginFormData.Password === "" ||
      LoginFormData.Password == null
    ) {
      alert("please Enter your password !");
    } else {
      dispatch(LOGIN_REQ(LoginFormData));
    }
  };

  useEffect(() => {
    if (accessToken) {
      Navigate("/");
    }
  });

  return (
    <>
      <section className="seLogin-wrapper">
        <div className="main-wrapper login-body">
          <div className="login-wrapper">
            <div className="container">
              <img
                className="img-fluid logo-dark mb-2"
                src="./assets/img/SE-logo.webp"
                alt="Search Education Logo"
              />
              <div className="loginbox">
                <div className="login-right">
                  <div className="login-right-wrap">
                    <h1>Login</h1>
                    <p className="account-subtitle">Access to our dashboard</p>
                    <form
                      onSubmit={(e) => handleSubmitForm(e)}
                      className="col-50">
                      {" "}
                      <div className="form-group text-field">
                        <input
                          type="text"
                          className="form-control"
                          id="Username"
                          name="Username"
                          onChange={handleFormChange}
                          value={LoginFormData.Username}
                          required
                        />
                        <label className="form-control-label">
                          Email Address
                        </label>
                      </div>
                      <div className="form-group text-field">
                        <input
                          id="password"
                          type="Password"
                          className="form-control"
                          name="Password"
                          onChange={handleFormChange}
                          value={LoginFormData.Password}
                          required
                        />

                        <i className="far fa-eye" id="togglePassword"></i>

                        <label className="form-control-label">Password</label>
                      </div>
                      <div className="form-group remember-index">
                        <div className="row">
                          <div className="col-12 col-md-6 p-0">
                            <div className="custom-control">
                              <input
                                type="checkbox"
                                id="indexUser"
                                name="Username"
                                onChange={handleFormChange}
                                value={LoginFormData.Username}
                              />
                              <span>Remember me</span>
                            </div>
                          </div>
                          <div className="col-12 col-md-6 text-end">
                            <a
                              className="forgot-link"
                              href="/Login/ForgotPassword">
                              Forgot Password?
                            </a>
                          </div>
                        </div>
                      </div>
                      <button
                        disabled={Login_Loading}
                        className="btn btn-md btn-block login-index-btn mt-4 "
                        type="submit">
                        {Login_Loading ? "Loading..." : "Login"}
                      </button>
                    </form>{" "}
                    <div className="text-center dont-have">
                      {Login_error && <b>{Login_error}</b>}
                      <br />

                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
